<script>
import {
  notificationMethods,
  contentMethods,
  courseMethods,
  examMethods,
  uploadMethods,
  sectionMethods
} from "@/state/helpers";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import Cookies from "js-cookie";
import api from "@/helpers/axios";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor';

/**
 * Advanced table component
 */
export default {
  props: {
    courseId: {
      type: String,
      required: true
    },
    examId: {
      type: String,
      required: true
    },
    sectionId: {
      type: String,
      required: true
    }
  },
  page: {
    title: "Kurs Detay",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    quillEditor

  },
  data() {
    return {
      sectionPage: 1,
      contentPage: 1,
      examPage: 1,

      contentTotalRows: 1,
      sectionTotalRows: 1,
      examTotalRows: 1,


      perPage: 10,
      pageOptions: [10, 25, 50, 100],


      addSubmitted: false,
      sectionAddSubmitted: false,
      sectionEditSubmitted: false,
      editSubmitted: false,
      noteAddSubmitted: false,
      noDeleteModal: false,
      examDeleteId: "",
      sectionDeleteId: "",
      //
      editModal: false,
      deleteModal: false,
      deleteExamModal: false,
      deleteSectionModal: false,
      deleteContentModal: false,
      deleteId: '',
      editId: "",
      //
      contents: [],
      exams: [],
      sections: [],
      //
      showContentModal: false,
      showExamModal: false,
      showSectionModal: false,
      //
      contentsLoaded: false,
      examsLoaded: false,
      sectionsLoaded: false,
      //
      noExamDeleteModal: false,
      noSectionDeleteModal: false,
      //
      examEditId: "",
      examEditModal: false,
      sectionEditId: "",
      sectionEditModal: false,
      //
      items: [],
      contentItems: [],
      examItems: [],
      sectionItems: [],
      //
      contentFields: [
        {
          key: "name",
          label: "İçerik Adı",
        },
        /*{
          key: "section",
          label: "Bölüm",
        },*/{
          key: "duration",
          label: "Süre",
        },
        {
          key: "isActive",
          label: "Durum",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      examFields: [
        {
          key: "name",
          label: 'Başlık'
        },
        {
          key: "examType",
          label: 'Tipi'
        },
        {
          key: "duration",
          label: 'Süre'
        },
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      sectionFields: [
        {
          key: "name",
          label: 'Başlık'
        },
        {
          key: "description",
          label: 'Açıklama'
        },
        {
          key: "isActive",
          label: 'Durum'
        },
        /* {
           key: "detail",
           label: "Detay",
         },*/
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      //
      pageInputContent: 1,
      pageInputExam: 1,
      pageInputSection: 1,
      //
      addForm: {
        name: "",
        description: "",
        image: "",
        video: "",
        file: "",
        duration: "",
        isActive: true,
        section: ""
      },
      editForm: {
        name: "",
        description: "",
        image: "",
        video: "",
        file: "",
        duration: "",
        isActive: true,
        section: ""
      },
      examAddForm: {
        name: "",
        description: "",
        examType: "",
        section: null,
        duration: "",
        isActive: true,
      },
      examEditForm: {
        name: "",
        description: "",
        examType: null,
        section: "",
        duration: "",
        isActive: true,
      },
      sectionAddForm: {
        name: "",
        description: "",
        isActive: true,
      },
      sectionEditForm: {
        name: "",
        description: "",
        isActive: true,
      },
      //
      selectedContent: "",
      //
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      //
      quillOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      },
      //
      selectedExamType: '',
      examTypes: [
        {label: 'Bölüm', value: 'unit'},
        {label: 'Kurs', value: 'course'},
      ],
      //
      customer: {},
      course: {},
      productTransactions: [],
      title: "Kurs Detay",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kurslar",
          href: "/courses"
        },
        {
          text: "Kurs Detay",
          active: true,
        },
      ],
      currentUser: JSON.parse(Cookies.get('user')),
      coursesLoaded: false,
      jointCourseFilter: '',
      personsLoaded: false,
      formSelectPersons: [],
      productsLoaded: false,
      formSelectProducts: [],
      formSelectJointCourses: [],
      selectedJointCourse: {},
      selectedEditJointCourse: {},
      quantityError: false,
      productId: 0,
      filter: null,
      filterOn: [],
      sortBy: "createdAt",
      sortDesc: false,

      //
      notes: [],
      notesLoaded: false,
      notesPage: 1,
      imgLoading: false,
      editImgLoading: false
    };
  },
  validations: {
    addForm: {
      name: {required},
      description: {required},
      video: {required},
      duration: {required},
      section: {required}
    },
    editForm: {
      name: {required},
      description: {required},
      video: {required},
      duration: {required},
      section: {required}
    },
    //
    examAddForm: {
      name: {required},
      duration: {required},
      description: {required},
      examType: {required}
      //  section:{required}
    }, examEditForm: {
      name: {required},
      duration: {required},
      description: {required},
      examType: {required}
      // isActive: {required},
    },
    sectionAddForm: {
      name: {required},
      description: {required},
    },
    sectionEditForm: {
      name: {required},
      description: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalSectionPages() {
      return Math.ceil(this.sectionTotalRows / this.perPage);
    }, totalContentPages() {
      return Math.ceil(this.contentTotalRows / this.perPage);
    }, totalExamPages() {
      return Math.ceil(this.examTotalRows / this.perPage);
    },
  },
  watch: {
    sectionPage(newSectionPage) {
      this.pageInputSection = newSectionPage;
      this.getSections(newSectionPage)
    },
    contentPage(newContentPage) {
      this.pageInputContent = newContentPage;
      this.getContents(newContentPage);
    },
    examPage(newExamPage) {
      this.pageInputExam = newExamPage;
      this.getExams(newExamPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getContents();
        } else {
          this.page = 1;
        }
      }
    },
    jointCustomerFilter(newFilter) {
      if (newFilter.length > 2) {
        this.getCoursesForFormSelect(newFilter)
      } else {
        this.formSelectJointCustomers = [];
      }
    },
  },
  mounted() {
    this.getExam()
    this.getCourse();
    this.getExams();
    this.getSections();
    this.getSectionCourses();
    this.getSection();
    this.getContents();
    this.getExamContents();
    this.getExamCourses();
  },
  methods: {
    ...contentMethods,
    ...courseMethods,
    ...examMethods,
    ...sectionMethods,
    ...notificationMethods,
    ...uploadMethods,
    //RESET FORMS
    resetSectionForm() {
      this.sectionAddForm = {
        name: null,
        description: null,
      };
      this.sectionEditForm = {
        name: null,
        description: null,
      },
          this.sectionAddSubmitted = false,
          this.sectionEditSubmitted = false;
    },
    resetContentForm() {
      this.addForm = {
        name: "",
        description: "",
        image: "",
        video: "",
        file: "",
        duration: "",
        isActive: true,
        section: ""
      };
      this.editForm = {
        name: "",
        description: "",
        image: "",
        video: "",
        file: "",
        duration: "",
        isActive: true,
        section: ""
      };
      this.noteAddSubmitted = false,
          this.editSubmitted = false;
    },
    resetExamForm() {
      this.examAddForm = {
        name: "",
        description: "",
        examType: "",
        section: null,
        duration: "",
        isActive: true,
      };
      this.examEditForm = {
        name: "",
        description: "",
        examType: null,
        section: "",
        duration: "",
        isActive: true,
      };
      this.addSubmitted = false,
          this.editSubmitted = false;
    },
//
    onlyAllowNumbers() {
      this.addForm.duration = this.addForm.duration.replace(/[^0-9]/g, '');
      this.editForm.duration = this.editForm.duration.replace(/[^0-9]/g, '');
      //
      this.sectionAddForm.duration = this.sectionAddForm.duration.replace(/[^0-9]/g, '');
      this.sectionEditForm.duration = this.sectionEditForm.duration.replace(/[^0-9]/g, '');
      //
      this.examAddForm.duration = this.examAddForm.duration.replace(/[^0-9]/g, '');
      this.examEditForm.duration = this.examEditForm.duration.replace(/[^0-9]/g, '');
    },
    //
    updateImageUrl(url) {
      this.imageUrl = url;
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'contents')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.image = res.url;
        this.imgLoading = false;
      })
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length) return;

      let data = new FormData();
      data.append("upload", files[0]);
      data.append("folder", "contents");
      let editForm = this.editForm;
      this.editImgLoading = true;
      this.uploadFile(data)
          .then((res) => {
            editForm.image = res.url;
            this.imageUrl = res.url;
            this.editImgLoading = false;
          });
      this.$v.editForm.image.$touch();
    },

    onFileChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'contents')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.file = res.url;
        this.imgLoading = false;
      })
    },
    onEditFileChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'contents')
      let editForm = this.editForm;
      this.editImgLoading = true;
      this.uploadFile(data).then((res) => {
        editForm.file = res.url;
        this.editImgLoading = false;
      })
    },
    getCourse() {
      this.itemsLoaded = false
      this.fetchCourse({id: this.$route.params.courseId}).then(res => {
        this.course = res
        this.itemsLoaded = true
      })
    },
    getContents(page = this.contentPage) {
      this.itemsLoaded = false;
      this.fetchContents({
        page,
        limit: this.perPage,
        search: this.search,
        courseId: this.$route.params.courseId
      })
          .then((res) => {
            this.contentTotalRows = res.total;
            this.contentItems = res.docs; // Assign content data to contentItems
            this.itemsLoaded = true;
          });
    },
    getExamContents() {
      this.itemsLoaded = false;
      this.fetchExamContents();
    },
    getExamCourses() {
      this.itemsLoaded = false;
      this.fetchExamCourses();
    },
    async fetchExamContents() {
      try {
        const courseId = this.$route.params.courseId;
        const response = await api.get(`/courses/${courseId}/contents`);
        this.contents = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    async fetchExamCourses() {
      try {
        // const courseId = this.$route.params.courseId;
        const response = await api.get(`/courses`);
        this.courses = response.data.data.docs;
        /* eslint-disable */
        console.log(response.data.data.docs + "5645465");
      } catch (error) {
        return
      }
    },
    getExams(page = this.examPage) {
      this.itemsLoaded = false;
      this.fetchExams({
        page,
        limit: this.perPage,
        search: this.search,
        courseId: this.$route.params.courseId
      })
          .then((res) => {
            this.examTotalRows = res.total;
            this.examItems = res.docs; // Assign exam data to examItems
            this.itemsLoaded = true;
          });
    },
    getExam() {
      this.itemsLoaded = false
      this.fetchExam({id: this.$route.params.examId}).then(res => {
        this.exam = res
        this.itemsLoaded = true
      })
    },
    getSectionCourses() {
      this.itemsLoaded = false;
      this.fetchSectionSections();
    },
    async fetchSectionSections() {
      try {
        const courseId = this.$route.params.courseId;
        const response = await api.get(`/courses/${courseId}/sections?listType=select`);
        this.sections = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    getSections(page = this.sectionPage) {
      this.itemsLoaded = false;
      this.fetchSections({
        page,
        limit: this.perPage,
        search: this.search,
        courseId: this.$route.params.courseId
      })
          .then((res) => {
            this.sectionTotalRows = res.total;
            this.sectionItems = res.docs; // Assign content data to contentItems
            this.itemsLoaded = true;
          });
    },
    getSection() {
      this.itemsLoaded = false
      this.fetchExam({id: this.$route.params.sectionId}).then(res => {
        this.section = res
        this.itemsLoaded = true
      })
    },
    getCoursesForFormSelect() {
      let filter = {search: this.jointCourseFilter}
      this.fetchCourses({listType: 'select', ...filter}).then(res => {
        this.formSelectJointCourses = res.docs.filter(doc => doc.id != this.$route.params.courseId);
      })
    },
    //sections işlemleri
    handleSectionSubmit() {
      this.sectionAddSubmitted = true;
      this.$v.sectionAddForm.$touch();
      if (
          this.$v.sectionAddForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.sectionAddForm))
        const courseId = this.$route.params.courseId;
        this.createSection({
          data, courseId
        }).then(() => {
          this.toastMessage = "Bölüm başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showSectionModal = false;
          this.getSections();
          this.sectionAddForm.name = "";
          this.sectionAddForm.description = "";
          this.sectionAddForm.isActive = "";
        })
      }
    },
    handleSectionEditSubmit() {
      this.sectionEditSubmitted = true;
      this.editFormError = ""
      this.$v.sectionEditForm.$touch();
      if (
          this.$v.sectionEditForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.sectionEditForm))
        const courseId = this.$route.params.courseId;
        this.updateSection({sectionId: this.sectionEditId, data, courseId}).then(() => {
          this.toastMessage = "Bölüm başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          this.sectionEditModal = false;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.examEditModal = false;
          this.getSections();
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleSectionDeleteSubmit() {
      const courseId = this.$route.params.courseId;
      this.deleteSection({sectionId: this.sectionDeleteId, courseId}).then(() => {
        this.deleteSectionModal = false;
        this.toastMessage = "Bölüm başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getSections();
      })
    },
    openSectionAdd() {
      this.resetSectionForm();
      this.jointCourseFilter = ''
      this.showSectionModal = true;
    },
    openSectionEdit(section) {
      this.sectionEditForm.name = section.name;
      this.sectionEditForm.description = section.description;
      this.sectionEditForm.isActive = section.isActive;
      this.sectionEditId = section.id;
      this.sectionEditModal = true;
    },
    openSectionDelete(section) {
      if (section.email === this.currentUser.email) {
        this.nosectionDeleteModal = true;
      } else {
        this.sectionDeleteId = section.id;
        this.deleteSectionModal = true;
      }
    },
    //contents işlemleri
    handleContentSubmit() {
      this.noteAddSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.addForm))


        if (data.image === "") {
          data.image = null;
        }
        if (data.file === "") {
          data.file = null;
        }
        const courseId = this.$route.params.courseId;
        this.createContent({
          data, courseId
        }).then(() => {
          this.toastMessage = "İçerik başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showContentModal = false;
          this.getContents();
          this.addForm.name = "";
          this.addForm.duration = "";
          this.addForm.video = "";
          this.addForm.description = "";
          this.addForm.isActive = "";
          this.addSubmitted = false;
        })
      }
    },
    handleContentEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.editForm))
        const courseId = this.$route.params.courseId;
        this.updateContent({contentId: this.editId, data, courseId}).then(() => {
          this.toastMessage = "İçerik başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.editForm.name = "";
          this.editForm.description = "";
          this.editForm.image = "";
          this.editForm.video = "";
          this.editForm.file = "";
          this.editForm.duration = "";
          this.editForm.section = "";
          this.editSubmitted = false;
          this.getContents();
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      const courseId = this.$route.params.courseId;
      this.deleteContent({contentId: this.deleteId, courseId}).then(() => {
        this.deleteContentModal = false;
        this.toastMessage = "İçerik başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getContents();
      })
    },
    openAdd() {
      this.resetContentForm()
      this.jointCourseFilter = ''
      this.showContentModal = true;
    },
    openEdit(content) {
      this.editForm.name = content.name;
      this.editForm.description = content.description;
      this.editForm.section = content.section;
      this.editForm.video = content.video;
      this.editForm.image = content.image;
      this.editForm.file = content.file;
      this.editForm.duration = content.duration;
      this.editForm.isActive = content.isActive;
      this.editId = content.id;
      this.editModal = true;
    },
    openDelete(content) {
      if (content.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = content.id;
        this.deleteContentModal = true;
      }
    },
    //exams işlemleri
    handleExamSubmit() {
      this.addSubmitted = true;
      this.$v.examAddForm.$touch();
      if (
          this.$v.examAddForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.examAddForm))
        const courseId = this.$route.params.courseId;
        this.createExam({
          data, courseId
        }).then(() => {
          this.toastMessage = "Sınav başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showExamModal = false;

          this.getExams();
          this.examAddForm.name = "";
          this.examAddForm.section = "";
          this.examAddForm.description = "";
          this.examAddForm.duration = "";
          this.examAddForm.isActive = "";
        })
      }
    },
    handleExamEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.examEditForm.$touch();
      if (
          this.$v.examEditForm.$invalid
      ) {
        return;
      } else {
        let data = JSON.parse(JSON.stringify(this.examEditForm))
        const courseId = this.$route.params.courseId;

        this.updateExam({examId: this.examEditId, data, courseId}).then(() => {
          this.toastMessage = "Sınav başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          this.showExamModal = false;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.examEditModal = false;
          this.getExams();
          this.examEditForm.name = "";
          this.examEditForm.section = "";
          this.examEditForm.description = "";
          this.examEditForm.duration = "";
          this.examEditForm.isActive = "";
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleExamDeleteSubmit() {
      const courseId = this.$route.params.courseId;
      this.deleteExam({examId: this.examDeleteId, courseId}).then(() => {
        this.deleteExamModal = false;
        this.toastMessage = "Sınav başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getExams();
      })
    },
    openExamAdd() {
      this.resetExamForm();
      this.jointCourseFilter = ''
      this.showExamModal = true;
    },
    openExamEdit(exam) {
      this.examEditForm.name = exam.name;
      this.examEditForm.description = exam.description;
      this.examEditForm.duration = exam.duration;
      this.examEditForm.isActive = exam.isActive;
      this.examEditForm.content = exam.content;
      this.examEditForm.examType = exam.examType;
      this.examEditForm.section = exam.section;
      this.examEditId = exam.id;
      this.examEditModal = true;
    },
    openExamDelete(exam) {
      if (exam.email === this.currentUser.email) {
        this.noExamDeleteModal = true;
      } else {
        this.examDeleteId = exam.id;
        this.deleteExamModal = true;
      }
    },
    //
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    },
    formatSection(section) {
      return section
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Adı :</th>
                  <td>{{ course.name }}</td>
                </tr>
                <tr v-for="(site, index) in course.site" :key="index">
                  <th scope="row">Site {{ index + 1 }}:</th>
                  <td>{{ site.name }}</td>
                </tr>
                <tr>
                  <th scope="row">Eğitim :</th>
                  <td>{{ course?.education?.name }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive col-6">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Danışman :</th>
                  <td>
                    {{ course?.advisor?.name }}
                  </td>
                </tr>

                <tr>
                  <th scope="row">Resim :</th>
                  <td><img :src="course.image" alt="course-image"
                           style="width: 75px!important; height: 55px; object-fit: contain; border-radius: 15px"
                           v-if="course.image"/></td>
                </tr>
                <tr>
                  <th scope="row">Fiyat :</th>
                  <td>{{ course.price }} TL</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--    sections işlemleri-->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Bölümler</h5>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openSectionAdd"
                >
                  Bölüm Ekle
                </button>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="sectionItems"
                  :fields="sectionFields"
                  responsive="sm"
              >
                <template v-slot:cell(courseId)="data">
                  {{ data.item.courseId.name }}
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(description)="data">
                  {{ data.item.description }}
                </template>
                <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
                  <span v-show="!data.item.isActive"
                        class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-warning d-flex py-2"
                      @click="openSectionEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openSectionDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <input :style="{width:'50px'}" @keyup.enter="sectionPage=pageInputSection"
                           v-model="pageInputSection" type="text" class="form-control">
                    <b-pagination
                        v-model="sectionPage"
                        :total-rows="sectionTotalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalSectionPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showSectionModal" title="Bölüm Ekle" hide-footer>
        <form @submit.prevent="handleSectionSubmit">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Bölüm Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="sectionAddForm.name"
                    class="form-control"
                    placeholder="Bölüm Adı giriniz"
                    :class="{
                    'is-invalid': sectionAddSubmitted && $v.sectionAddForm.name.$error,
                  }"
                />
                <div v-if="sectionAddSubmitted && !$v.sectionAddForm.name.required"
                     class="invalid-feedback">
                  Bölüm Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Açıklama</label>
                <input
                    id="name"
                    type="text"
                    v-model="sectionAddForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                    :class="{
                    'is-invalid': sectionAddSubmitted && $v.sectionAddForm.name.$error,
                  }"
                />
                <div v-if="sectionAddSubmitted && !$v.sectionAddForm.description.required"
                     class="invalid-feedback">
                  Açıklama girilmesi gerekli bir alandır.
                </div>

              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="sectionAddForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showSectionModal = false; resetSectionForm();"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Bölüm Ekle
            </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="sectionEditModal" title="Bölümü düzenle" hide-footer>
        <form @submit.prevent="handleSectionEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Bölüm Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="sectionEditForm.name"
                    class="form-control"
                    placeholder="Bölüm Adı giriniz"
                    :class="{
                    'is-invalid': sectionEditSubmitted && $v.sectionEditForm.name.$error,
                  }"
                />
                <div v-if="sectionEditSubmitted && !$v.sectionEditForm.name.required"
                     class="invalid-feedback">
                  Bölüm Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Açıklama</label>
                <input
                    id="name"
                    type="text"
                    v-model="sectionEditForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                    :class="{
                    'is-invalid': sectionEditSubmitted && $v.sectionEditForm.description.$error,
                  }"
                />
                <div v-if="sectionEditSubmitted && !$v.sectionEditForm.description.required"
                     class="invalid-feedback">
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="sectionEditForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="sectionEditModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Bölümü düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteSectionModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu bölümü silmek istediğinize emin misiniz? Silinmiş bölümü geri alamazsınız.
              </p>
              <form @submit.prevent="handleSectionDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noSectionDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bölümü silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>

      <!--    contents işlemleri-->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>İçerikler</h5>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openAdd"
                >
                  İçerik Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="contentItems"
                  :fields="contentFields"
                  responsive="sm"
              >

                <!--                <template v-slot:cell(section)="data">
                                  {{ formatSection(data?.item?.section?.id) }}
                                </template>-->

                <template v-slot:cell(courseId)="data">
                  {{ data.item.courseId.name }}
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(duration)="data">
                  {{ data.item.duration }}
                </template>
                <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
                  <span v-show="!data.item.isActive"
                        class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
                </template>
                <template v-slot:cell(detail)="data">
                  <button
                      class="btn btn-info d-flex py-2"
                      @click="$router.push({name:'contentDetail',params:{contentId: data.item.id}})"
                  >
                    <i :class="`bx bxs-detail bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="contentPage=pageInputContent"
                           v-model="pageInputContent" type="text" class="form-control">
                    <b-pagination
                        v-model="contentPage"
                        :total-rows="contentTotalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalContentPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showContentModal" title="İçerik Ekle" hide-footer>
        <form @submit.prevent="handleContentSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="site">Bölüm Seçiniz</label>
                  <select id="site" v-model="addForm.section" class="form-control" :class="{
                    'is-invalid': noteAddSubmitted && $v.addForm.section.$error,
                  }">
                    <option value="">Bölüm Seçiniz</option>
                    <option v-for="section in sections" :key="section.id" :value="section.id">{{
                        section.name
                      }}
                    </option>
                  </select>
                  <div
                      v-if="noteAddSubmitted && !$v.addForm.section.required"
                      class="invalid-feedback"
                  >
                    Bölüm seçilmesi gerekli bir alandır.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">İçerik Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="İçerik Adı giriniz"
                    :class="{
                    'is-invalid': noteAddSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="noteAddSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="duration">Süre(dk)</label>
                <input
                    id="duration"
                    type="number"
                    v-model="addForm.duration"
                    class="form-control"
                    placeholder="Süre giriniz"
                    @input="onlyAllowNumbers"
                    :class="{
                    'is-invalid': noteAddSubmitted && $v.addForm.duration.$error,
                  }"
                />
                <div
                    v-if="noteAddSubmitted && !$v.addForm.duration.required"
                    class="invalid-feedback"
                >
                  Süre girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="video">Video</label>
                <input
                    id="video"
                    type="text"
                    v-model="addForm.video"
                    class="form-control"
                    placeholder="Video Url giriniz"
                    :class="{
                    'is-invalid': noteAddSubmitted && $v.addForm.video.$error,
                  }"
                />
                <div
                    v-if="noteAddSubmitted && !$v.addForm.video.required"
                    class="invalid-feedback"
                >
                  Video girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="image" class="form-label">Fotoğraf</label>
                <input
                    type="file"
                    id="image"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"

                />

              </div>

            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="file">Dosya (PDF veya Word)</label>
                <input
                    type="file"
                    id="file"
                    @change="onFileChange"
                    accept="file/*"
                    class="form-control"

                />

              </div>

            </div>


            <div class="col-12">
              <div class="mb-3">
                <label for="description">Açıklama</label>
                <quill-editor
                    v-model="addForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                    :class="{
                    'is-invalid': noteAddSubmitted && $v.addForm.description.$error,
                  }"
                ></quill-editor>
                <div
                    v-if="noteAddSubmitted && !$v.addForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="addForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showContentModal = false; resetContentForm()"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >İçerik Ekle
            </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="İçeriği düzenle" hide-footer>
        <form @submit.prevent="handleContentEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">

                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <label for="site">Bölüm Seçiniz</label>
                        <select id="site" v-model="editForm.section" class="form-control" :class="{
                    'is-invalid': editSubmitted && $v.editForm.section.$error,
                  }">
                          <option value="">Bölüm Seçiniz</option>
                          <option v-for="section in sections" :key="section.id" :value="section.id">{{
                              section.name
                            }}
                          </option>
                        </select>
                        <div
                            v-if="editSubmitted && !$v.editForm.section.required"
                            class="invalid-feedback"
                        >
                          Bölüm seçilmesi gerekli bir alandır.
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">İçerik Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="İçerik Adı giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="duration">Süre(dk)</label>
                <input
                    id="duration"
                    type="text"
                    v-model="editForm.duration"
                    class="form-control"
                    placeholder="Süre giriniz"
                    @input="onlyAllowNumbers"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.duration.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.duration.required"
                    class="invalid-feedback"
                >
                  Süre girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="video">Video</label>
                <input
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.video.$error,
                  }"
                    id="video"
                    type="text"
                    v-model="editForm.video"
                    class="form-control"
                    placeholder="Video Url giriniz"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.video.required"
                    class="invalid-feedback"
                >
                  Video gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="file">Dosya (PDF veya Word)</label>
                <input
                    type="hidden"
                    v-model="editForm.file"
                    class="form-control"
                />
                <input
                    type="file"
                    id="file"
                    @change="onEditFileChange"
                    accept="file/*"
                    class="form-control"

                />
              </div>

            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description" :class="{
                    'is-invalid': editSubmitted && $v.editForm.description.$error,
                  }">Açıklama</label>
                <quill-editor
                    v-model="editForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
                <div
                    v-if="editSubmitted && !$v.editForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Fotoğraf</label>
                <div class="row">
                  <div class="col-6">
                    <input
                        type="file"
                        id="image"
                        @change="onEditImageChange"
                        accept="image/*"
                        class="form-control"
                    />
                  </div>
                  <div class="col-6">
                    <div v-if="editForm.image" class="mt-2 text-center">
                      <img :src="editForm.image" alt="Mevcut Resim" style="max-width: 50%; max-height: 100px;"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="editForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >içeriği düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteContentModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu içeriği silmek istediğinize emin misiniz? Silinmiş içeriği geri alamazsınız.
              </p>
              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız içeriği silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
      <!--    exams işlemleri-->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Sınavlar</h5>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="openExamAdd"
                >
                  Sınav Ekle
                </button>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="examItems"
                  :fields="examFields"
                  responsive="sm"
              >
                <template v-slot:cell(courseId)="data">
                  {{ data.item.courseId.name }}
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:cell(duration)="data">
                  {{ data.item.duration }}
                </template>
                <template v-slot:cell(examType)="data">
                  <div v-if="data.item.examType==='unit'">Bölüm</div>
                  <div v-if="data.item.examType==='course'">Kurs</div>
                </template>
                <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
                  <span v-show="!data.item.isActive"
                        class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
                </template>
                <template v-slot:cell(detail)="data">
                  <button
                      class="btn btn-info d-flex py-2"
                      @click="$router.push({name:'examDetail',params:{examId: data.item.id, courseId: courseId}})"
                  >
                    <i :class="`bx bxs-detail bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-warning d-flex py-2"
                      @click="openExamEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-danger d-flex py-2"
                      @click="openExamDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <input :style="{width:'50px'}" @keyup.enter="examPage=pageInputExam" v-model="pageInputExam"
                           type="text" class="form-control">
                    <b-pagination
                        v-model="examPage"
                        :total-rows="examTotalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalExamPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showExamModal" title="Sınav Ekle" hide-footer>
        <form @submit.prevent="handleExamSubmit">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Sınav Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="examAddForm.name"
                    class="form-control"
                    placeholder="Sınav Adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.examAddForm.name.$error,
                  }"
                />
                <div v-if="addSubmitted && !$v.examAddForm.name.required"
                     class="invalid-feedback">
                  Sınav Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="duration">Süre (dk)</label>
                <input
                    id="duration"
                    type="number"
                    v-model="examAddForm.duration"
                    class="form-control"
                    placeholder="Süre giriniz"
                    @input="onlyAllowNumbers"
                    :class="{
                    'is-invalid': addSubmitted && $v.examAddForm.duration.$error,
                  }"
                />
                <div v-if="addSubmitted && !$v.examAddForm.duration.required"
                     class="invalid-feedback">
                  Süre girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Açıklama </label>
                <input
                    id="description"
                    type="text"
                    v-model="examAddForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.examAddForm.description.$error,
                  }"
                />
                <div v-if="addSubmitted && !$v.examAddForm.description.required"
                     class="invalid-feedback">
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="examType">Sınav Tipi Seçiniz</label>
                  <select id="examType" v-model="examAddForm.examType" class="form-control" :class="{
                    'is-invalid': addSubmitted && $v.examAddForm.examType.$error,
                  }">
                    <option value="">Sınav Tipi Seçiniz</option>
                    <option v-for="(examType, index) in examTypes" :key="index" :value="examType.value">
                      {{ examType.label }}
                    </option>
                  </select>
                  <div v-if="addSubmitted && !$v.examAddForm.examType.required"
                       class="invalid-feedback">
                    Sınav tipi seçimi gerekli bir alandır.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="examAddForm.examType === 'unit'">
              <div class="mb-3">
                <div class="form-group">
                  <label for="contentSelect">Bölüm Seçiniz. <span class="text-info">Sınavda, seçilen bölüme kadar olan kısımdan sorumlu olunacaktır.</span></label>
                  <select id="contentSelect" v-model="examAddForm.section" class="form-control">
                    <option value="">Bölüm Seçiniz</option>
                    <option
                        v-for="section in sections"
                        :key="section.id"
                        :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="examAddForm.examType === 'course'">
              <div class="d-none">
                <input
                    id="name"
                    type="text"
                    v-model="examAddForm.content"
                    class="form-control"
                    placeholder="Sınav Adı giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="examAddForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showExamModal = false; resetExamForm()"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Sınav Ekle
            </b-button>
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="examEditModal" title="Sınavı düzenle" hide-footer>
        <form @submit.prevent="handleExamEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Sınav Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="examEditForm.name"
                    class="form-control"
                    placeholder="Sınav Adı giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="duration">Süre(dk)</label>
                <input
                    id="duration"
                    type="number"
                    v-model="examEditForm.duration"
                    class="form-control"
                    placeholder="Süre giriniz"
                    @input="onlyAllowNumbers"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="description">Açıklama </label>
                <input
                    id="description"
                    type="text"
                    v-model="examEditForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="examType">Sınav Tipi Seçiniz</label>
                  <select id="examType" v-model="examEditForm.examType" class="form-control">
                    <option v-for="(examType, index) in examTypes" :key="index" :value="examType.value">
                      {{ examType.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>


            <div class="col-12" v-if="examEditForm.examType === 'unit'">
              <div class="mb-3">
                <div class="form-group">
                  <label for="contentSelect">Bölüm Seçiniz. <span class="text-info">Sınavda, seçilen bölüme kadar olan kısımdan sorumlu olunacaktır.</span></label>
                  <select id="contentSelect" v-model="examEditForm.section" class="form-control">
                    <option value="">Bölüm Seçiniz</option>
                    <option
                        v-for="section in sections"
                        :key="section.id"
                        :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="examEditForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="examEditModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Sınavı düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteExamModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu sınavı silmek istediğinize emin misiniz? Silinmiş sınavı geri alamazsınız.
              </p>
              <form @submit.prevent="handleExamDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noExamDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız sınavı silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.customSelect .dropdown-menu {
  width: 100% !important;
}

.customSelect .btn {
  text-align: left;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>

